import OtsUploadFile from './OtsUploadFile'

OtsUploadFile.install = Vue => {
    Vue.component(OtsUploadFile.name,OtsUploadFile)
}

export default OtsUploadFile
